module.exports = __webpack_public_path__ + "static/media/210.d8e49aaa.jpg";